import {usePlayer} from '@/components/player-v2/PlayerProvider';
import {BasicCtaTimelineElement} from '@/components/player-v2/TimelineElement/BasicCtaTimelineElement';

type SeekToTimelineElementProps = {
  icon?: React.ReactElement;
  iconPosition?: 'left' | 'right';
  seekToSeconds: number;
  text: string;
};

/**
 * Timeline element component that enables the ability to skip forward in the video.
 */
export const SeekToTimelineElement: React.FC<SeekToTimelineElementProps> = ({
  icon,
  iconPosition,
  seekToSeconds,
  text,
}) => {
  const {seekTo} = usePlayer();
  return (
    <BasicCtaTimelineElement
      icon={icon}
      iconPosition={iconPosition}
      text={text}
      onClick={() => seekTo(seekToSeconds)}
    />
  );
};
